import PublicEnv from 'shared/utils/public-env';

const isBackofficeHosted = typeof window !== 'undefined' && /^\/ecomm(?:\/|$)/.test(window.location.pathname);
const scopeIdPattern = /^[A-Za-z0-9_-]+$/;

export function getBackofficeHostedRequestHeaders(): Record<string, string> {
  if (!isBackofficeHosted) return {};

  const path = window.location.pathname;
  const enterprise = /^\/ecomm\/enterprise\/([^/]+)(?:\/|$)/.exec(path);
  const dispensary = /^\/ecomm\/dispensaries\/([^/]+)(?:\/|$)/.exec(path);

  try {
    if (enterprise) {
      const id = decodeURIComponent(enterprise[1]);
      return scopeIdPattern.test(id) ? { 'x-dutchie-enterprise-id': id } : {};
    }
    if (dispensary) {
      const id = decodeURIComponent(dispensary[1]);
      return scopeIdPattern.test(id) ? { 'x-dutchie-dispensary-id': id } : {};
    }
  } catch {
    // The proxy rejects absent scope for malformed deep links.
  }
  return {};
}

const AdminPublicEnv = {
  ...PublicEnv,
  adminBasePath: isBackofficeHosted ? '/ecomm' : undefined,
  graphqlUri: isBackofficeHosted ? '/api/ecom_admin/graphql' : PublicEnv.graphqlUri,
  isBackofficeHosted,
  useGetForHashedQueries: !isBackofficeHosted,
};

export default AdminPublicEnv;
